import React from 'react';

export const ColorContext = React.createContext({
    headerColor: '',
    changeHeaderColor: () => {} //that has to be empty function, the shape of context object has to match
});
